<template>
  <div class="flex justify-center gap-4 mt-4">
    <!-- Horas -->
    <div class="bg-black p-4 rounded-lg flex flex-col items-center">
      <p class="text-4xl font-bold text-white bg-[#484848] px-0.5">
        {{ String(hours).padStart(2, '0') }}
      </p>
      <span class="text-xs uppercase text-gray-300">horas</span>
    </div>

    <!-- Minutos -->
    <div class="bg-black p-4 rounded-lg flex flex-col items-center">
      <p class="text-4xl font-bold text-white bg-[#484848] px-0.5">
        {{ String(minutes).padStart(2, '0') }}
      </p>
      <span class="text-xs uppercase text-gray-300">minutos</span>
    </div>

    <!-- Segundos -->
    <div class="bg-black p-4 rounded-lg flex flex-col items-center">

      <p class="text-4xl font-bold text-white bg-[#484848] px-0.5">
        {{ String(seconds).padStart(2, '0') }}
      </p>
      <span class="text-xs uppercase text-gray-300">segundos</span>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted, defineEmits } from 'vue'

const props = defineProps({
  initialHours: { type: Number, required: true },
  initialMinutes: { type: Number, required: true },
  initialSeconds: { type: Number, required: true }
})

// converte tudo para segundos
const timeLeft = ref(
  props.initialHours * 3600 +
  props.initialMinutes * 60 +
  props.initialSeconds
)

const emit = defineEmits(['finished'])
const hours = computed(() => Math.floor(timeLeft.value / 3600))
const minutes = computed(() => Math.floor((timeLeft.value % 3600) / 60))
const seconds = computed(() => timeLeft.value % 60)

let intervalId
onMounted(() => {
  intervalId = setInterval(() => {
    if (timeLeft.value > 0) {
      timeLeft.value--
    } else {
      clearInterval(intervalId)
      // opcional: emitir um evento para avisar que zerou
      emit('finished', true)
    }
  }, 1000)
})

onUnmounted(() => {
  clearInterval(intervalId)
})
</script>

<style scoped>
/* se quiser esconder a scrollbar em mobile, etc. */
</style>
